const Layout = r =>
  require.ensure([], () => r(require('@/layout/layout1.vue')), 'base')

const dashboard = r =>
  require.ensure(
    [],
    () => r(require('@/modules/enterpriseAdmin/dashboard/dashboard.vue')),
    'enterpriseAdmin'
  )

const dataDashboard = r =>
  require.ensure(
    [],
    () => r(require('@/modules/tenantManager/dashboard/dashboard.vue')),
    'tenant'
  )
const companyInfo = r =>
  require.ensure(
    [],
    () =>
      r(require('@/modules/enterpriseAdmin/enterpriseSetting/companyInfo.vue')),
    'enterpriseAdmin'
  )

const orgStructure = r =>
  require.ensure(
    [],
    () =>
      r(
        require('@/modules/enterpriseAdmin/enterpriseSetting/orgStructure.vue')
      ),
    'enterpriseAdmin'
  )

const employee = r =>
  require.ensure(
    [],
    () =>
      r(require('@/modules/enterpriseAdmin/enterpriseSetting/employee.vue')),
    'enterpriseAdmin'
  )

const attendanceCode = r =>
  require.ensure(
    [],
    () =>
      r(
        require('@/modules/enterpriseAdmin/enterpriseSetting/attendanceCode.vue')
      ),
    'enterpriseAdmin'
  )

const deviceManager = r =>
  require.ensure(
    [],
    () =>
      r(require('@/modules/enterpriseAdmin/deviceManager/deviceManager.vue')),
    'enterpriseAdmin'
  )

const deviceDetails = r =>
  require.ensure(
    [],
    () =>
      r(require('@/modules/enterpriseAdmin/deviceManager/deviceDetails.vue')),
    'enterpriseAdmin'
  )

const attendanceRecord = r =>
  require.ensure(
    [],
    () =>
      r(
        require('@/modules/enterpriseAdmin/enterpriseSetting/attendanceRecord.vue')
      ),
    'enterpriseAdmin'
  )

const witnessCheck = r =>
  require.ensure(
    [],
    () =>
      r(
        require('@/modules/enterpriseAdmin/enterpriseSetting/witnessCheck.vue')
      ),
    'enterpriseAdmin'
  )
const accRecord = r =>
  require.ensure(
    [],
    () =>
      r(require('@/modules/enterpriseAdmin/enterpriseSetting/accRecord.vue')),
    'enterpriseAdmin'
  )

const updateHistory = r =>
  require.ensure(
    [],
    () =>
      r(
        require('@/modules/enterpriseAdmin/deviceManager/deviceCmp/updateHistory.vue')
      ),
    'enterpriseAdmin'
  )

const enterpriseAdmin = [
  {
    path: '/board',
    name: 'board',
    redirect: '/tenantDashboard/dashboard',
    component: Layout,
    meta: {
      auth: false,
      breadcrumbShow: true,
      id: 'b338a2b64ce74380b9e68d4aaeac65eb'
    },
    children: [
      {
        path: '/tenantDashboard/dashboard',
        name: 'tenantDashboard',
        component: dataDashboard,
        meta: {
          id: 'b9ba4a654c804819bc9c950d6f179633',
          breadcrumbShow: true,
          auth: true
        }
      },
      {
        path: '/board/dashboard',
        name: 'enterprisedashboard',
        component: dashboard,
        meta: {
          id: 'cb7a8c8cabcf467dbf97dd1a2e0e805c',
          auth: true
        }
      }
    ]
  },

  {
    path: '/deviceManager',
    name: 'deviceManager',
    component: Layout,
    meta: {
      id: '631e31f5fb624662b9ca9b7b31df6996',
      auth: true
    },
    redirect: '/deviceManager/deviceList',
    children: [
      {
        path: '/deviceManager/deviceList',
        name: 'deviceList',
        component: deviceManager,
        meta: {
          id: '61fb7be1773a4b0f960d2ce001805b8c',
          auth: true,
          showApp: true,
          asParams: true,
          showCompany: true,
          showAll: true
        }
      },
      {
        path: '/deviceManager/updateHistory',
        name: 'updateHistory',
        component: updateHistory,
        meta: {
          id: '6278d452281547a59701ba6c380e2cce',
          auth: true
        }
      },
      {
        path: '/deviceManager/deviceDetails',
        name: 'deviceDetails',
        component: deviceDetails,
        hidden: true,
        meta: {
          id: 'bfbce7a67d454461bc15f568b21ea209',
          auth: false
          // showApp: true,
          // asParams: true,
          // showCompany: true,
          // showAll: true
        }
      }
    ]
  },
  {
    path: '/enterpriseAdmin',
    name: 'enterpriseAdmin',
    component: Layout,
    meta: {
      id: '1c1ec9b71f944898a378b3599ee15e1e',
      auth: true
    },
    redirect: '/enterpriseAdmin/companyInfo',
    children: [
      {
        path: 'companyInfo',
        name: 'companyInfo',
        component: companyInfo,
        meta: {
          id: '1fe493217972449f86a66c23aef983dc',
          auth: true
        }
      },
      {
        path: 'orgStructure',
        name: 'orgStructure',
        component: orgStructure,
        meta: {
          id: '4d262839398d459e8a9fee1afd306d7f',
          auth: true,
          showCompany: true,
          asParams: true,
          showApp: true
        }
      },
      {
        path: 'employee',
        name: 'employee',
        component: employee,
        meta: {
          id: '14e4f378d304424082a907befe92567a',
          auth: true,
          showCompany: true,
          asParams: true,
          showApp: true
        }
      },
      {
        path: 'attendanceCode',
        name: 'attendanceCode',
        component: attendanceCode,
        meta: {
          id: '801bf07a4db64e308c293a3fc67caaab',
          auth: true
        }
      }
    ]
  },

  {
    path: '/datareport',
    name: 'datareport',
    component: Layout,
    meta: {
      id: 'a75715a926c6406aabaf8c0864a39c40',
      auth: true
    },
    redirect: '/datareport/attendanceRecord',
    children: [
      {
        path: '/datareport/attendanceRecord',
        name: 'attendanceRecord',
        component: attendanceRecord,
        meta: {
          id: 'daeb92f53c04484cad5843b1feb03f35',
          auth: true,
          showApp: true,
          asParams: true,
          showCompany: true,
          showAll: false
        }
      },
      {
        path: '/datareport/witnessCheck',
        name: 'witnessCheck',
        component: witnessCheck,
        meta: {
          id: '9a7165036b2e4bddb90247069a682f4b',
          auth: true,
          showApp: true,
          asParams: true,
          showCompany: true,
          showAll: false
        }
      },
      {
        path: '/datareport/accRecord',
        name: 'accRecord',
        component: accRecord,
        meta: {
          id: '06797cdf15304701a82ee186c3f83877',
          auth: true,
          showApp: true,
          asParams: true,
          showCompany: true,
          showAll: false
        }
      }
    ]
  }
]
export default enterpriseAdmin



// WEBPACK FOOTER //
// ./src/pages/index/router/modules/enterpriseAdmin.js